import { render } from "./ClientMenu.vue?vue&type=template&id=0f12ce72&scoped=true"
import script from "./ClientMenu.vue?vue&type=script&lang=js"
export * from "./ClientMenu.vue?vue&type=script&lang=js"

import "./ClientMenu.vue?vue&type=style&index=0&id=0f12ce72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f12ce72"]])

export default __exports__